var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useEffect, useRef, useState } from "react";
import { ConfigContext } from "../../hooks/ConfigContext";
import { Wrapper } from "@googlemaps/react-wrapper";
import Marker from './Marker';
import "../PropertyDetails/property-styles.scss";
function GoogleMap(_a) {
    var center = _a.center, mapType = _a.mapType, zoom = _a.zoom, pin = _a.pin, desc = _a.desc;
    var _b = useState(null), infowindow = _b[0], setInfowindow = _b[1];
    var _c = useState(null), map = _c[0], setMap = _c[1];
    var _d = useState(null), marker = _d[0], setMarker = _d[1];
    var ref = useRef();
    var content = "\n    <div class=\"map-Info-Window\"> \n      <p> ".concat(desc, " </p>\n    </div>\n  ");
    useEffect(function () {
        var m = new window.google.maps.Map(ref.current, {
            center: center,
            zoom: zoom,
            disableDefaultUI: true,
            zoomControl: true
        });
        setMap(m);
    }, []);
    useEffect(function () {
        setInfowindow(new window.google.maps.InfoWindow());
    }, []);
    useEffect(function () {
        var mapMarker = new window.google.maps.Marker({
            position: pin,
            icon: 'data:image/svg+xml;charset=utf-8,' + Marker(mapType)
        });
        setMarker(mapMarker);
    }, [pin.lat]);
    useEffect(function () {
        if (!marker) {
            return;
        }
        if (map) {
            marker.setMap(map);
            infowindow.open(map, marker);
            infowindow.setContent(content);
        }
        return function () {
            if (marker) {
                marker.setMap(null);
            }
            if (infowindow) {
                infowindow.setContent(null);
                infowindow.close();
            }
        };
    }, [marker]);
    return _jsx("div", { ref: ref, id: "map", className: "map-radius", style: { width: '100%', height: 240 } });
}
export default function Map(_a) {
    var address = _a.address, mapType = _a.mapType;
    var _b = useState({
        lat: 0.0,
        lng: 0.0
    }), center = _b[0], setCenter = _b[1];
    useEffect(function () {
        setCenter({ lat: address.lat, lng: address.lng });
    }, [address.lat]);
    var zoom = 15;
    var config = useContext(ConfigContext);
    var apiKey = config === null || config === void 0 ? void 0 : config["google-maps-key"];
    if (!apiKey || !(center === null || center === void 0 ? void 0 : center.lat)) {
        return null;
    }
    return (_jsx(Wrapper, __assign({ apiKey: apiKey }, { children: center.lat && _jsx(GoogleMap, { mapType: mapType, center: center, zoom: zoom, pin: center, desc: address.desc }) })));
}
